import { AnalyticsStore, codeSplit, Controller, FetchOptions, Result } from 'bernie-core';
import { PageData } from 'bernie-http';
import '../client/temp-common-imports';
import analyticsUtil from '../util/AnalyticsUtil';

export class SignInController implements Controller {
  public pageId = 'SignIn';
  public path = '/:localeName/signin';
  public routeName = 'signin';
  public bundles = [];

  public component = codeSplit(() => import(/* webpackChunkName: "signin-page" */ '../views/signin-page'));
  public exact = true;

  public fetch(options: FetchOptions): Promise<Result> {
    const { stores, request } = options;
    const analyticsStore: AnalyticsStore = stores && stores.get<AnalyticsStore>('analytics');

    const pageName = 'page.affhub.signin';
    const context = request.context;

    analyticsUtil.runAnalytics(pageName, analyticsStore, context);

    return Promise.resolve(Result.ok());
  }

  public fetchPageData(): Promise<PageData> {
    return Promise.resolve({ title: 'Expedia Affiliate Program' }) as Promise<PageData>;
  }
}
